"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._storage = exports._cookie = void 0;
exports._cookie = {
    TOKEN: "__token__",
};
exports._storage = {
    USER_INFO: "userInfo",
};
